export default __webpack_public_path__ + "static/media/opal.92c9c304.png";